import { BehaviorParameter } from "./behaviors";
import { BaseData, ListForcePackageData, RadioProfileRef } from "./common";
import { Confounder } from "./systems";

export interface AssessmentData extends BaseData {
	calc_status?: string;
	id: number;
	name: string;
	creation_date?: string;
	programming_scenarios?: { id: number; name: string }[];
}

export interface AssessmentScenarioData {
	name: string;
	blue_headstart: number;
	blue_force_package: number;
	red_force_package: number;
	geography: string;
	resolution: string;
	mission: string;
	crossborder_blue: boolean;
	rcs_calculation: boolean;
	confounders: Confounder[];
	target_selection: "centralized" | "selfAssigned";
	scenario_events: Array<ScenarioEvent> | null;
	event_variability: number;
	bandwidth_limitations: boolean;
	pathloss_propagation: boolean;
	zones: number[];

	blue_behavior_settings: Record<number, BehaviorParameter[]>;
	red_behavior_settings: Record<number, BehaviorParameter[]>;
	systems: Record<number, ListForcePackageData & { cost: number | string; symbol: string; radio_profile_refs?: RadioProfileRef[] }>;

	blue_echelon_settings: Record<number, BehaviorParameter[]>;
	red_echelon_settings: Record<number, BehaviorParameter[]>;

	id: number;
}

export interface ScenarioEventInputData {
	id: number;
	name: string;
	base_event: string;
	parameters: Record<string, any>;
}

export interface ScenarioEvent {
	time: number;
	event_id: number;
	duration: number;
}

// Type guard to check if the value is a whole JSON object of AssessmentScenarioData instead of a single property
export function isWholeJson(
	value: AssessmentScenarioData[keyof AssessmentScenarioData] | AssessmentScenarioData
): value is AssessmentScenarioData {
	return (value as AssessmentScenarioData)?.blue_behavior_settings !== undefined;
}
